const defaultState = {
    products: [],
    employees: [],
    resources: [],
};
export const disabled = (state = defaultState, action) => {
    const {payload, type} = action;
    if (!payload) return state;
    switch (type) {
        case 'DISABLED_EMPLOYEES':
        case 'DISABLED_PRODUCTS':
        case 'DISABLED_RESOURCES':
            return {
                ...state,
                ...payload,
            }
        case 'REMOVE_EMPLOYEE_DISABLED':
            return {
                ...state,
                employees: []
            }
        case 'REMOVE_ALL_DISABLED': 
            return {
                ...defaultState
            }
        default:
            return state;
    }
}